<template>
  <div>
    <v-dialog v-model="ownerTemporaryActionsDialog" persistent max-width="900">
      <v-card>
        <v-toolbar :color="systemBarColors.bar" height="40" window>
          <v-icon class="ms-2" v-if="important">mdi-bell-alert</v-icon>
          <span class="ms-2 text-black">{{ $t('Owner_Temporary_Actions') }}</span>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              closeParent();
              ownerTemporaryActionsDialog = false
            "
            icon
            ><v-icon :color="systemBarColors.icon">mdi-close-circle-outline</v-icon></v-btn
          >
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card-text> {{ message }} </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- Return to Original -->
                <v-dialog v-model="returnToOriginalDialog" persistent max-width="600px">
                  <template v-slot:activator="{ props: activatorProps }">
                    <v-btn text class="card-button mx-1 mb-0" :disabled="!canReturnToOriginal" v-bind="activatorProps">{{
                      $t('Return_To_Original_Condition')
                    }}</v-btn>
                  </template>
                  <v-card>
                    <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                    <v-card-text class="text-h6 font-weight-bold">{{ $t('Return_To_Original_Condition') }}</v-card-text>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            {{ $t('Return_To_Original_Condition_Text') }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" text class="card-button" @click="returnToOriginalDialog = false">{{ $t('Cancel') }}</v-btn>
                      <!-- inner dialog -->
                      <v-dialog v-model="returnToOriginalSecondConfirmationDialog" persistent max-width="600px">
                        <template v-slot:activator="{ props: activatorProps }">
                          <v-btn color="primary" text class="card-button" v-bind="activatorProps">{{ $t('OK') }}</v-btn>
                        </template>
                        <v-card>
                          <v-toolbar color="warning" dense>
                            <v-spacer></v-spacer>
                            <v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
                          </v-toolbar>
                          <v-card-text class="text-h6 font-weight-bold">{{ $t('Return_To_Original_Condition') }}</v-card-text>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12">{{ $t('Return_To_Original_Confirmation') }}</v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="error"
                              class="card-button"
                              text
                              @click="
                                returnToOriginalCondition(false);
                                returnToOriginalDialog = false
                              "
                            >
                              {{ $t('NO') }}
                            </v-btn>
                            <v-btn
                              color="primary"
                              text
                              class="card-button"
                              @click="
                                returnToOriginalCondition(true);
                                returnToOriginalDialog = false
                              "
                            >
                              {{ $t('YES') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <!-- /inner dialog -->
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- /Return to Original -->

                <!-- Make Permanent -->
                <v-dialog v-model="makePermanentDialog" persistent max-width="600px">
                  <template v-slot:activator="{ props: activatorProps }">
                    <v-btn text class="card-button mx-1 mb-0" :disabled="!canMakePermanent" v-bind="activatorProps">
                      {{ $t('Make_Permanent') }}
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar color="warning" dense>
                      <v-toolbar-title>{{ $t('Make_Permanent') }}</v-toolbar-title
                      ><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
                    </v-toolbar>
                    <v-card-text>
                      <v-container>
                        {{ $t('Make_Permanent_Text') }}
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <!-- inner dialog for OK -->
                      <v-dialog v-model="makePermanentEditDialog" persistent max-width="600px">
                        <template v-slot:activator="{ props: activatorProps }">
                          <v-btn text class="card-button mx-1 mb-0"  v-bind="activatorProps">
                            {{ $t('OK') }}
                          </v-btn>
                        </template>
                        <v-card>
                          <v-toolbar color="warning" dense>
                            <v-toolbar-title>{{ $t('Make_Permanent') }}</v-toolbar-title
                            ><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
                          </v-toolbar>
                          <v-card-text>
                            <v-container>
                              {{ $t('Make_Permanent_Editable_Text') }}
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              class="card-button mx-1 mb-0"
                              @click="
                                submitMakePermanentOwnerEditable();
                                makePermanentDialog = false
                              "
                            >
                              {{ $t('OK') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <!-- /inner dialog for OK -->
                      <v-btn
                        text
                        class="card-button mx-1 mb-0"
                        @click="
                          makePermanentDialog = false;
                          closeParent()
                        "
                      >
                        {{ $t('Cancel') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- /Make Permanent -->

                <!-- Extend -->
                <v-dialog v-model="extendDialog" persistent max-width="600px">
                  <template v-slot:activator="{ props: activatorProps }">
                    <v-btn text class="card-button mx-1 mb-0" :disabled="!canExtend" v-bind="activatorProps">
                      {{ $t('Extend') }}
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar color="warning" dense>
                      <v-toolbar-title>{{ $t('Extend') }}</v-toolbar-title
                      ><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
                    </v-toolbar>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            {{ $t('Extend_Select_Date') }}
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-menu
                            v-model="formSettings.ownerExtendValidUntilDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ props }">
                              <v-text-field
                                :model-value="displayCalculatedValue"
                                :label="$t('Valid_Until_Date')"
                                prepend-icon="mdi-calendar-outline"
                                readonly
                                variant="underlined"
                                name="ownerExtendValidUntilDate"
                                v-bind="props"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :model-value="selectedDate"                              
                              no-title
                              hide-header
                              :min="minOwnerApprovalDate"
                              :max="maxOwnerApprovalDate"
                              v-on:update:model-value="updateValue"
                            ></v-date-picker>
                          </v-menu>
                        </v-row>

                        <template v-if="this.modelValue !='' && originalOwnerApprovalDatePlus180 >= convertDatetoString(selectedDate)  && !hideYes">
                          <v-card-text>                            
                            {{ $t('Extended_Under_180_Message', { newValidUntilDate: displayCalculatedValue }) }}
                          </v-card-text>
                        </template>

                        <template v-if="this.modelValue !='' && originalOwnerApprovalDatePlus180 < convertDatetoString(selectedDate)">
                          <v-card-text>                            
                            {{ $t('Extended_Over_180_Message', { newValidUntilDate: displayCalculatedValue }) }}
                            {{ $t('Extended_Over_180_Link_Label') }}
                            <v-icon @click="$t('Extended_Over_180_Link')">mdi-open-in-new</v-icon>
                          </v-card-text>
                        </template>

                        <template v-if="hideYes || (this.modelValue !='' && originalOwnerApprovalDatePlus180 < convertDatetoString(selectedDate))">
                          <v-row>
                            <v-col cols="12">
                              <v-expansion-panels>
                                <v-expansion-panel>
                                  <v-expansion-panel-title disable-icon-rotate @click="show = !show"
                                    >All Approvers
                                    <template v-slot:actions>
                                      <v-icon>{{ show ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                                    </template>
                                  </v-expansion-panel-title>
                                  <v-expansion-panel-text>
                                    <v-list-group v-for="(selectedUser, index) in allCurrentApprovers" :key="index">
                                      <template v-slot:activator>
                                        <v-list-item>
                                          <template v-if="selectedUser != null">
                                            <v-list-item-title>{{ selectedUser.displayName }}</v-list-item-title>
                                            <v-list-item-subtitle class="job-title">{{
                                              selectedUser.jobTitle
                                            }}</v-list-item-subtitle>
                                          </template>
                                        </v-list-item>
                                      </template>
                                      <user-details
                                        @closeDetails="selectedUser.active = false"
                                        :user="selectedUser"
                                      ></user-details>
                                    </v-list-group>
                                  </v-expansion-panel-text>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-col>
                          </v-row>
                        </template>

                        <template v-if="(this.modelValue !='' && originalOwnerApprovalDatePlus180 < convertDatetoString(selectedDate)) || showAdditionalApprovers">
                          <v-row>
                            <v-col cols="12" sm="12">
                              <people-picker-ms
                                :label="$t('Additional_Approvers')"
                                v-model="tempExtendAdditionalApprovers"
                                :title="$t('Additional_Approvers')"
                                @update="args => this.handleUpdateAdditionalApprovers(args)"
                                @beforeDelete="handleRemoveAdditionalApprover"
                                ref="AdditionalApproversPeoplePicker"
                                bulkUserAdd
                              ></people-picker-ms>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <people-picker-ms
                                :label="$t('Additional_FYI')"
                                v-model="tempExtendAdditionalFyis"
                                :title="$t('Additional_FYI')"
                                @update="args => this.handleUpdateAdditionalFyis(args)"
                                @beforeDelete="handleRemoveAdditionalFyis"
                                ref="AdditionalFyisPeoplePicker"
                                bulkUserAdd
                              ></people-picker-ms>
                            </v-col>
                          </v-row>
                          <user-group-message-dialog
                            :showDialog="userGroupMessageDialogShow"
                            :message="userGroupMessageDialogMessage"
                            :messageOnly="userGroupMessageDialogMessageOnly"
                            :user="userGroupMessageDialogUser"
                            :childGroup="userGroupMessageDialogChildGroup"
                            :parentGroup="userGroupMessageDialogParentGroup"
                            :keepBothOnYes="userGroupMessageDialogKeepBothOnYes"
                            @results="setGroupUsers($event)"
                          ></user-group-message-dialog>
                        </template>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <template v-if="this.modelValue !='' && originalOwnerApprovalDatePlus180 > convertDatetoString(selectedDate)">
                        <v-btn
                          text
                          class="card-button"
                          @click="
                            manualAddAdditionalApprovers = true;
                            showAdditionalApprovers = true;
                            needsAdditionalInput = true;
                            showHideYesNo()
                          "
                          v-show="!hideYes"
                        >
                          {{ $t('Yes') }}
                        </v-btn>

                        <v-btn
                          text
                          class="card-button"
                          @click="
                            submitExtend(needsAdditionalInput);
                            extendDialog = false
                          "
                          :disabled="disableExtendSubmit()"
                        >
                          {{ noToSubmit ? $t('Submit') : $t('No') }}
                        </v-btn></template
                      >
                      <template v-if="this.modelValue !='' && originalOwnerApprovalDatePlus180 < convertDatetoString(selectedDate)">
                        <v-btn
                          text
                          class="card-button"
                          @click="
                            needsAdditionalInput = true;
                            submitExtend(needsAdditionalInput);
                            extendDialog = false
                          "
                          :disabled="disableExtendSubmit()"
                        >
                          {{ $t('Submit') }}
                        </v-btn></template
                      >
                      <v-btn
                        text
                        class="card-button"
                        @click="
                          clearValuesOnCancel();
                          extendDialog = false
                        "
                      >
                        {{ $t('Cancel') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- /Extend -->

                <v-btn
                  color="primary"
                  class="card-button"
                  text
                  @click="
                    closeParent();
                    ownerTemporaryActionsDialog = false
                  "
                  >{{ $t('Cancel') }}</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import MOCService from '@/services/moc.service'
import { PeoplePickerActions } from '@/common/peoplePickerActions'
import { AdvanceType } from '@/common/systemTypes'
import PeoplePickerMs from '@/components/peoplePicker/PeoplePickerMs'
import UserGroupMessageDialog from '@/components/mocForm/UserGroupMessageDialog'
import { alreadyRequiredUsers, arrayContainsUser } from '@/common/userFunctions'
import Toaster from '@/components/Toaster'
import LoadingDialog from '@/components/mocForm/LoadingDialog'
import { FormStatus, Roles } from '@/common'
import UserDetails from '@/components/peoplePicker/UserDetails'
import dateMixins from '@/mixins/dateMixins'
import moment from 'moment'
import { Flags } from '../../common/flags'
export default {
  emits: ['update:modelValue'],
  name: 'OwnerTemporaryActions',
  mixins: [dateMixins],
  data: () => ({
    modelValue: '',
    saveLoading: false,
    returnToOriginalConditionLoading: false,
    makePermanentLoading: false,
    extendLoading: false,
    ownerTemporaryActionsDialog: true,
    returnToOriginalDialog: false,
    returnToOriginalSecondConfirmationDialog: false,
    extendDialog: false,
    makePermanentDialog: false,
    makePermanentEditDialog: false,
    formSettings: {
      ownerExtendValidUntilDateMenu: false
    },
    tempAdditionalApprovers: [],
    tempAdditionalFyis: [],
    userGroupMessageDialogShow: false,
    userGroupMessageDialogMessage: '',
    userGroupMessageDialogMessageOnly: true,
    userGroupMessageDialogUser: {},
    userGroupMessageDialogChildGroup: [],
    userGroupMessageDialogParentGroup: [],
    userGroupMessageDialogKeepBothOnYes: false,
    showAdditionalApprovers: false,
    approverCount: 0,
    value: null,
    tempExtendAdditionalApprovers: [],
    tempExtendAdditionalFyis: [],
    manualAddAdditionalApprovers: false,
    systemBarColors: {
      bar: 'grey',
      icon: 'error'
    },
    noToSubmit: false,
    hideYes: false,
    hideNo: true,
    show: false,
    needsAdditionalInput: false
  }),
  props: {  
 
    fromDialog: {
      type: Boolean,
      default: false
    },
    message: {
      type: String
    },
    tasks: {
      type: Array
    },
    moc: {
      type: Object
    },
    important: {
      type: Boolean
    }
  },
  components: {
    PeoplePickerMs,
    UserGroupMessageDialog,
    Toaster,
    LoadingDialog,
    UserDetails
  },
  methods: {
    clearValuesOnCancel() {
      this.value = null
      this.showAdditionalApprovers = false
      this.noToSubmit = false
      this.hideYes = false
      this.hideNo = true
      this.tempExtendAdditionalFyis = []
      this.tempExtendAdditionalApprovers = []
      this.needsAdditionalInput = false
      this.modelValue = ''
    },
    closeParent() {
      this.$emit('close')
    },
    disableExtendSubmit() {
      if (this.originalOwnerApprovalDatePlus180 < this.value) {
        if (!this.manualAddAdditionalApprovers && this.value && this.tempExtendAdditionalApproversCount > 0) {
          return false
        }
        return true
      }

      if (!this.manualAddAdditionalApprovers && this.value) {
        return false
      }
    },
    fetchMoc(communityAbbrev, id) {
      this.setLoaded(false)
      // we have a live one here!
      return new Promise((resolve, reject) => {
        MOCService.getMocById(communityAbbrev, id)
          .then(data => {
            this.moc = data.item1
            this.myRoles = data.item2
            this.previousFormStatus = data.item3
            this.setLoaded(true)
            resolve()
          })
          .catch(() => {
            console.error(this.$t('Error_MOCForm', { mocId: id }))
            reject()
          })
      })
    },
    handleRemoveAdditionalApprover: function(removedUser, people, done) {
      done()
      return
    },
    handleRemoveAdditionalFyis: function(removedUser, people, done) {
      done()
      return
    },
    handleUpdateAdditionalApprovers: function(usersAction) {
      let user = []
      // only check the currently added user
      if (usersAction.Users && usersAction.Users.length > 0) {
        user.push(usersAction.Users[usersAction.Users.length - 1])
      }

      let approverUsers = usersAction.Users
      if (usersAction.Action === PeoplePickerActions.properties[PeoplePickerActions.ADD].value) {
        let arePresetApproversUsers = alreadyRequiredUsers(this.moc.roles.approvers, user)
        let areAdditionalApprovers = alreadyRequiredUsers(this.moc.roles.additionalApprovers, user)
        let arePresetFyisUsers = alreadyRequiredUsers(this.moc.roles.fyis, user)
        let areAdditionalFyisUsers = alreadyRequiredUsers(this.moc.roles.additionalFyis, user)
        let areTempExtendAdditionalFyis = alreadyRequiredUsers(this.tempExtendAdditionalFyis, user)

        // remove owner from approvers IF SUBMITTED and currentuser is facilitator or back up
        if (
          this.moc.status.value === FormStatus.properties[FormStatus.SUBMITTED].value &&
          (this.myRoles.includes(Roles.properties[Roles.FACILITATOR].value) ||
            this.myRoles.includes(Roles.properties[Roles.FACILITATORBACKUP].value))
        ) {
          if (arrayContainsUser(approverUsers, this.moc.roles.owner)) {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyOwner', { person: this.moc.roles.owner.displayName })
          }
        }

        if (arePresetApproversUsers.length > 0) {
          arePresetApproversUsers.forEach(u => {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
          })
        }

        if (areAdditionalApprovers.length > 0) {
          areAdditionalApprovers.forEach(u => {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
          })
        }

        arePresetFyisUsers.forEach(u => {
          this.userGroupMessageDialogShow = true
          this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
        })

        areAdditionalFyisUsers.forEach(u => {
          this.userGroupMessageDialogShow = true
          this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
        })

        if (areTempExtendAdditionalFyis.length > 0) {
          areTempExtendAdditionalFyis.forEach(u => {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
          })
        }
      }
      this.tempExtendAdditionalApprovers = approverUsers
    },
    handleUpdateAdditionalFyis: function(usersAction) {
      let user = []
      // only check the currently added user
      if (usersAction.Users && usersAction.Users.length > 0) {
        user.push(usersAction.Users[usersAction.Users.length - 1])
      }

      let fyiUsers = usersAction.Users
      if (usersAction.Action === PeoplePickerActions.properties[PeoplePickerActions.ADD].value) {
        let arePresetApproversUsers = alreadyRequiredUsers(this.moc.roles.approvers, user)
        let arePresetFyisUsers = alreadyRequiredUsers(this.moc.roles.fyis, user)
        let areAdditionalApproverUsers = alreadyRequiredUsers(this.moc.roles.additionalApprovers, user)
        let areAdditionalFyisUsers = alreadyRequiredUsers(this.moc.roles.additionalFyis, user)
        let areTempExtendAdditionalApprovers = alreadyRequiredUsers(this.tempExtendAdditionalApprovers, user)

        // remove owner from fyis IF SUBMITTED and currentuser is facilitator or back up
        if (
          this.moc.status.value === FormStatus.properties[FormStatus.SUBMITTED].value &&
          (this.myRoles.includes(Roles.properties[Roles.FACILITATOR].value) ||
            this.myRoles.includes(Roles.properties[Roles.FACILITATORBACKUP].value))
        ) {
          if (arrayContainsUser(fyiUsers, this.moc.roles.owner)) {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyOwner', { person: this.moc.roles.owner.displayName })
          }
        }
        if (arePresetApproversUsers.length > 0) {
          arePresetApproversUsers.forEach(u => {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
          })
        }
        if (arePresetFyisUsers.length > 0) {
          arePresetFyisUsers.forEach(u => {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
          })
        }
        if (areAdditionalApproverUsers.length > 0) {
          areAdditionalApproverUsers.forEach(u => {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
          })
        }
        areAdditionalFyisUsers.forEach(u => {
          this.userGroupMessageDialogShow = true
          this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
        })
        if (areTempExtendAdditionalApprovers.length > 0) {
          areTempExtendAdditionalApprovers.forEach(u => {
            this.userGroupMessageDialogShow = true
            this.userGroupMessageDialogMessage = this.$t('Info_AlreadyHasRole', { person: u.displayName })
          })
        }
      }
      this.tempExtendAdditionalFyis = fyiUsers
    },
    returnToOriginalCondition: function(returnedToOriginal) {
      let rto = new Boolean(returnedToOriginal)

      if (rto === true) {
        if (!this.moc.flags.includes('r2oTrue')) {
          this.moc.flags.push('r2oTrue')
        }
      } else {
        if (!this.moc.flags.includes('r2oFalse')) {
          this.moc.flags.push('r2oFalse')
        }
      }
      this.submitReturnToOriginal()
    },
    setBar() {
      if (this.important) {
        this.systemBarColors.bar = 'error'
        this.systemBarColors.icon = 'black'
      }
    },
    setGroupUsers: function(results) {
      // this is a strange function that works with the results from the userGroupMessageDialog
      switch (results.groupName) {
        case 'fyis':
          this.tempAllRequiredFyis = results.users
          break
        case 'addtionalApprovers':
          this.$refs.AdditionalApproversPeoplePicker.removeSelectedUser(results.users)
          break
        case 'owner':
          this.moc.roles.owner = { ...results.users }
          break
      }

      //lets reset stuff
      this.userGroupMessageDialogShow = false
      this.userGroupMessageDialogMessage = ''
      this.userGroupMessageDialogMessageOnly = true
      this.userGroupMessageDialogUser = {}
      this.userGroupMessageDialogChildGroup = []
      this.userGroupMessageDialogParentGroup = []
      this.userGroupMessageDialogKeepBothOnYes = false
    },
    showHideYesNo: function() {
      if (this.modelValue !== '' && this.originalOwnerApprovalDatePlus180 >this.convertDatetoString(this.selectedDate)) {
        this.noToSubmit = true
        this.hideYes = true
      } else {
        this.noToSubmit = false
        this.hideYes = false
      }
    },
    submitExtend: function(needsInput) {
      this.saveLoading = true
      this.moc.flags.push('extend')

      this.moc.dates.validUntilHold = this.moc.dates.validUntil
      this.moc.dates.validUntil = this.calculatedValue // new Date(this.calculatedValue).toISOString()

      if (this.tempExtendAdditionalApproversCount > 0) {
        var ids = new Set(this.moc.roles.additionalApprovers.map(u => u.id));
        this.moc.roles.additionalApprovers = [...this.moc.roles.additionalApprovers, ...this.tempExtendAdditionalApprovers.filter(u => !ids.has(u.id))];

      }

      if (this.tempExtendAdditionalFyisCount > 0) {
        var ids = new Set(this.moc.roles.additionalFyis.map(u => u.id));
        this.moc.roles.additionalFyis = [...this.moc.roles.additionalFyis, ...this.tempExtendAdditionalFyis.filter(u => !ids.has(u.id))];
      }

      let advanceType = AdvanceType.ADVANCE

      if (!needsInput) {
        advanceType = AdvanceType.NONE
      }

      const data = this.moc
      this.$refs.loadingDialog.show()
      MOCService.save(data, advanceType)
        .then(result => {
          if (result.success) {
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_OwnerFormChanges') })
          } else {
            throw new Error(result.message)
          }
        })
        .catch(e => {
          this.$refs.loadingDialog.error({
            metadata: 'submitExtend',
            error: e,
            message: this.$t('Error_Extend')
          })
        })
    },
    submitMakePermanentOwnerEditable: function() {
      if (!this.moc.flags) {
        this.moc.flags = []
      }
      if (!this.moc.flags.includes('ownereditablemakepermanent')) {
        this.moc.flags.push('ownereditablemakepermanent')
      }

      const data = this.moc
      this.$refs.loadingDialog.show()
      MOCService.save(data, AdvanceType.NONE)
        .then(result => {
          if (result.success) {
            // redirect to self
            this.$router.go({
              path: this.$router.path,
              query: {
                t: +new Date()
              }
            })
          } else {
            throw new Error(result.message)
          }
        })

        .catch(e => {
          this.$refs.loadingDialog.error({
            metadata: 'submitMakePermanentOwnerEditable',
            error: e
          })
        })
    },
    submitReturnToOriginal: function() {
      if (!this.moc.flags) {
        this.moc.flags = []
      }
      if (!this.moc.flags.includes('returntooriginalcondition')) {
        this.moc.flags.push('returntooriginalcondition')
      }

      const data = this.moc
      this.$refs.loadingDialog.show()
      MOCService.save(data, AdvanceType.ADVANCE)
        .then(result => {
          if (!result.success) {
            throw new Error(result.message)
          }
        })
        .then(() => {
          this.$refs.loadingDialog.hide({ redirect: true })
        })
        .catch(e => {
          this.$refs.loadingDialog.error({
            metadata: 'submitReturnToOriginal',
            error: e,
            message: this.$t('Error_ReturnToOriginal')
          })
        })
    },
    updateValue: function(value) {
      this.formSettings.ownerExtendValidUntilDateMenu = false
      let now = moment()
      let time = now.hour() + ':' + now.minute() + ':' + now.second()
      //this.value = moment(value + ' ' + time).format()
     // this.modelValue = moment(value + ' ' + time).format()
      let dateString = value.getFullYear() + '-' + this.getTimeLeftPad(value.getMonth() + 1)  + '-' + this.getTimeLeftPad(value.getDate())      
      console.log(`moment(dateString + ' ' + time).format() ${moment(dateString + ' ' + time).format()}`)
      // this.$emit('update:modelValue', moment(dateString + ' ' + time).format())
      this.modelValue = moment(dateString + ' ' + time).format()
    },
    convertDatetoString: function(value){
      if(!value)
      return '';
      console.log(this.getTimeLeftPad(value.getMonth() + 1))
      return value.getFullYear() + '-' + this.getTimeLeftPad(value.getMonth() + 1)  + '-' + this.getTimeLeftPad(value.getDate())      
      

    },
    getTimeLeftPad: function(number){      
      if(number.toString().length < 2){
        return '0' + number
      }
      return number
    }
  },
  computed: {
    allCurrentApprovers() {
      let concatAndDeDuplicate = (...arrs) => [...new Set([].concat(...arrs))]

      return concatAndDeDuplicate(this.moc.roles.approvers, this.moc.roles.additionalApprovers)
    },
    displayCalculatedValue() {
      console.log(`this.formattedDate ${this.formattedDate}`)
      return this.formattedDate ? this.$filters.DateFilter(this.formattedDate) : ''
    },
    calculatedValue() {
      return this.formattedDate ? new Date(this.formattedDate).toISOString() : ''
    },
    canExtend() {
      let withinDateRange = false

      let originalOwnerApprovedStartDate = new Date(this.moc.dates.approvedStart)

      let maxExtendDate = originalOwnerApprovedStartDate.setDate(originalOwnerApprovedStartDate.getDate() + 360)

      withinDateRange = maxExtendDate > Date.now()

      let maxLessThanValidUntil = moment(maxExtendDate).isAfter(moment(this.moc.dates.validUntil))

      return (
        withinDateRange &&
        maxLessThanValidUntil &&
        (!this.moc.flags.includes(Flags.properties[Flags.MAKEPERMANENT].key) &&
          !this.moc.flags.includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key) &&
        !this.moc.flags.includes(Flags.properties[Flags.EXTEND].key)
      )
      )
    },
    canMakePermanent() {
      if (
        (this.moc.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value ||
          this.moc.status.value ===
            FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value) &&
        !this.moc.flags.includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key) &&
        !this.moc.flags.includes(Flags.properties[Flags.MAKEPERMANENT].key)
      ) {
        return true
      }

      return false
    },
    canReturnToOriginal() {
      if (
        this.moc.status.value ===
          FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value &&
        !this.moc.flags.includes(Flags.properties[Flags.MAKEPERMANENT].key) &&
        !this.moc.flags.includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key) &&
        !this.moc.flags.includes(Flags.properties[Flags.EXTEND].key)
      ) {
        return true
      }
      return false
    },
    minOwnerApprovalDate() {
      if (this.moc.dates.validUntil) {
        if (
          moment(this.moc.dates.validUntil)
            .add(1, 'd')
            .isSameOrAfter(moment(this.maxOwnerApprovalDate))
        ) {
          return moment(this.maxOwnerApprovalDate).startOf('day').format()
        }

        if (moment(this.moc.dates.validUntil).isSameOrBefore(moment())) {
          return moment()
            .add(1, 'd').startOf('day')
            .format()
        }

        return moment(this.moc.dates.validUntil)
          .add(1, 'd').startOf('day')
          .format()
      }
      return moment()
        .add(1, 'd').startOf('day')
        .format()
    },
    maxOwnerApprovalDate() {
       var date = new Date(this.moc.dates.approvedStart)
      // wait a second, if there is history then we need to use the first approval date
      if (this.moc.ownerDecision.history) {
        date = new Date(this.moc.ownerDecision.history[0].decisionDate)
      }

      date.setDate(date.getDate() + 360)
      return this.formatDate(date)
    },
    originalOwnerApprovalDatePlus180() {
      var date = new Date(this.moc.dates.approvedStart)
      // wait a second, if there is history then we need to use the first approval date
      if (this.moc.ownerDecision.history) {
        date = new Date(this.moc.ownerDecision.history[0].decisionDate)
      }

      date.setDate(date.getDate() + 180)
      return this.formatDate(date)
    },
    selectedDate: function() {
      console.log(`this.modelValue ${this.modelValue}`)
      if (!this.modelValue) return null      
      return new Date(this.modelValue)
    },
    tempExtendAdditionalApproversCount() {
      return this.tempExtendAdditionalApprovers.length
    },
    tempExtendAdditionalFyisCount() {
      return this.tempExtendAdditionalFyis.length
    }
  },
  created() {
    this.setBar()
  }
}
</script>

<style scoped></style>
